import { AxiosRequestConfig } from 'axios';
import { merge } from 'lodash';

import { generateAuthHeaders } from '@src/factories';

import Client from './client';

export enum Type {
  PRIME = 0,
  POST = 1,
  TOUR = 2,
  USER = 3,
  JOURNEY = 4,
  BUSINESS = 5,
}

type CollectionListItem = {
  id: string;
  text?: string;
  objectId?: string;
};

type Data = {
  id?: string;
  type: Type;
  listItems: CollectionListItem[];
};

type Response = {
  readonly result: 'SUCCESS' | 'ERROR';
  readonly status: number;
};

export default (
  id: string,
  accessToken: string,
  data: Data,
  config?: AxiosRequestConfig
) => {
  return Client.post<Response>(
    `/col/v1/collections/${id}/items`,
    data,
    merge(config, generateAuthHeaders(accessToken))
  );
};
